import { createContext, useContext } from 'react';

/**
 * Lets a DataTable render its "Columns" show/hide control into a host-provided
 * slot (e.g. TablePage's search row) instead of its own inline toolbar, so the
 * columns button shares a row with the search input + bulk actions.
 *
 * The value is the slot DOM node, or `null` while the host's slot is still
 * mounting. `undefined` (the default, i.e. no provider) means standalone, in
 * which case DataTable falls back to its inline toolbar. The undefined-vs-null
 * distinction lets DataTable avoid flashing the inline toolbar for one render
 * before a host slot attaches.
 */
const TableToolbarSlotContext = createContext<HTMLElement | null | undefined>(undefined);

export const TableToolbarSlotProvider = TableToolbarSlotContext.Provider;

export const useTableToolbarSlot = () => useContext(TableToolbarSlotContext);

export default TableToolbarSlotContext;
